import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const APP_STORE_URL = 'https://apps.apple.com/ca/app/album-cards/id6749836488';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.technotsar.albumcards';
const FALLBACK_CARD = '/card.webp';

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000',
    color: '#dbdbd0',
    fontFamily: "'Host Grotesk', sans-serif",
    textAlign: 'center',
    padding: '0 24px',
  },
  card: { width: 200, maxWidth: '70%', borderRadius: 10, opacity: 0.95 },
  title: { fontSize: '2rem', fontWeight: 600, margin: '24px 0 8px' },
  subtitle: { fontSize: '1rem', fontWeight: 300, opacity: 0.8, maxWidth: 420, margin: '0 0 32px' },
  buttons: { display: 'flex', gap: 16, flexWrap: 'wrap', justifyContent: 'center' },
  button: {
    display: 'inline-block',
    padding: '14px 28px',
    border: '1px solid #dbdbd0',
    borderRadius: 999,
    color: '#dbdbd0',
    textDecoration: 'none',
    fontSize: '0.95rem',
    fontWeight: 500,
  },
};

export default function CardFound() {
  const { code } = useParams<{ code: string }>();
  // The tapped card's image — fetched by code. The album's title/audio are
  // never exposed here; only the physical card face is shown.
  const [cardImage, setCardImage] = useState<string | null>(null);

  useEffect(() => {
    if (!code || typeof fetch !== 'function') return;
    let cancelled = false;
    fetch(`/c/${encodeURIComponent(code)}/card`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancelled && data && data.cardImage) setCardImage(data.cardImage);
      })
      .catch(() => {
        /* keep the generic fallback */
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <div style={styles.page}>
      <img src={cardImage || FALLBACK_CARD} alt="" style={styles.card} />
      <h1 style={styles.title}>You&rsquo;ve found an Album Card</h1>
      <p style={styles.subtitle}>
        There&rsquo;s music locked inside. Get the app, then tap the card
        again to unlock it.
      </p>
      <div style={styles.buttons}>
        <a style={styles.button} href={APP_STORE_URL}>
          Download on the App Store
        </a>
        <a style={styles.button} href={PLAY_STORE_URL}>
          Get it on Google Play
        </a>
      </div>
    </div>
  );
}
